export function insert_leads_to_db(form) {
    let action_name = 'save_leads_to_db';
    let form_url = form.attr('action');
    let form_url_ajax = form_url.replace('admin-post.php', 'admin-ajax.php');
    let post_data = form.serialize() + '&current_url=' + encodeURIComponent(window.location.href);

    // change action name
    post_data = post_data.replace(/action=[^&]+/, 'action=' + action_name);

    $.ajax({
      type: form.attr('method'),
      url: form_url_ajax,
      data: post_data,
      beforeSend: function() {
        
      },
      success: function (data) {
        if (data.success == true) {
          console.info('Insert to DB is successful');
        } else {
          console.info('Insert to DB is failed');
        }
      },
      error: function () {
        console.info('Insert to DB is error');
      },
    });
}



// WEBPACK FOOTER //
// ./scripts/global/leads-submission.js